import { createAction } from 'redux-actions';

export const showModalOnLoad = createAction(
  'BROWSE.SHOW_MODAL_ON_LOAD',
  (modalToShowOnLoad: string, modalParams: any) => ({
    modalToShowOnLoad,
    modalParams,
  })
);
